/**
 * Generic Model.
 */
import Observable from "../util/observable";
export default class ObservableBaseModel extends Observable{

    constructor(data = undefined) {
        super();
    }


}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/ObservableBaseModel.js